import React from 'react';

const CurrentActionOwnerInfo = ({ data, lastDatasetShown }) => {

  return (
    <div
      className="current-info"
      style={{ borderColor: data.colour }}
    >
      <p><strong>{ lastDatasetShown ? "Current a" : "A" }ction owner</strong></p>
      <p><strong>{ lastDatasetShown ? "Since" : "When" }</strong></p>
      <p>
        <strong>Duration</strong>
        <span className="ml-1 smallish">(business time)</span>
      </p>
      <div className="action-owner-grid">
        <i
          className={`fa fa-${data.icon}`}
          style={{ color: data.colour }}
        ></i>
        <p>
          {data.label}
        </p>
      </div>
      <p>
        {data.startedAt}
        { lastDatasetShown ? '' : ` - ${data.endedAt}` }
      </p>
      <p>
        {data.durationString}
      </p>
    </div>
  );
}

export default CurrentActionOwnerInfo;
